import React from 'react';
import classnames from 'classnames';

import styles from './ConnectSourceIcon.scss';

interface IConnectSourceOuter {
  children: React.ReactNode;
  className?: string;
}

export const ConnectSourceIcon: React.FC<IConnectSourceOuter> = ({ children, className }) => (
  <div className={classnames(styles.icon, className)}>
    <div className={styles.iconComponentContainer}>{children}</div>
  </div>
);
